import type { IComponentEvent } from '@wix/editor-elements-types/corvid';
import type { DefaultCompPlatformProps } from '@wix/editor-elements-types/thunderbolt';
// import type * as yup from 'yup';
// // Should be exported / defined in editor-elements-types
//
import type {
  IFocusPropsSDKActions,
  IElementPropsSDKActions,
} from '@wix/editor-elements-corvid-utils';
import type { A11yInteractions } from '@wix/editor-elements-types/a11y';

export type ICaptchaMapperProps = {
  language: string;
};

export type ICaptchaImperativeActions = {
  reset: () => void;
  focus: () => void;
};

export type ICaptchaProps = ICaptchaMapperProps &
  DefaultCompPlatformProps &
  Partial<IElementPropsSDKActions> &
  Partial<IFocusPropsSDKActions> &
  A11yInteractions & {
    ref?: React.Ref<ICaptchaImperativeActions>;
    token: string;
    isMobileFriendly?: boolean;
    className?: string;
    onTokenChange: (token?: string) => void;
    onError?: (e: IComponentEvent<'onError'>) => void;
    onTimeout?: (e: IComponentEvent<'onTimeout'>) => void;
    onVerified?: (e: IComponentEvent<'onVerified'>) => void;
  };

export const SM_ERROR_CODES = {
  CAPTCHA_REQUIRED: '19971',
  CAPTCHA_INVALID: '19970',
} as const;
